import * as types from './constants';

// Assign Code
export const assignCodeRequest = data => (
  { type: types.ASSIGN_CODE_REQUEST, payload: data }
);

export const assignCodeDone = data => (
  { type: types.ASSIGN_CODE_DONE, payload: data }
);

export const assignCodeFailed = errors => (
  { type: types.ASSIGN_CODE_FAILED, payload: errors }
);

export const assignCodeReset = () => (
  { type: types.ASSIGN_CODE_RESET }
);